import { render } from "./ModalFormCambiaPass.vue?vue&type=template&id=05a44f34"
import script from "./ModalFormCambiaPass.vue?vue&type=script&lang=js"
export * from "./ModalFormCambiaPass.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__